<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>Dedications to Gideon Lowy who was responsible for turning loose ideas into a scientific theory.</p><br/>
<p style="text-indent:0em">Michael Wood who edited the book and helped to keep ideas on the right set of rails.</p><br/>
<p style="text-indent:0em">Zach Bishop who helped to organise a mountain of information into a library that is easy to use.</p><br/>
<p style="text-indent:0em">To Lou whose generation now has the correct foundations to rebuild science from the base up.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?5c2c3b2b